"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isVideoPlaylistCard = exports.isVideoCard = exports.isScoreCard = exports.isNewsCard = exports.isMatchupCard = exports.isLeagueCard = void 0;
var _abstract_1 = require("../_abstract");
__exportStar(require("./icon-card"), exports);
__exportStar(require("./league-card"), exports);
__exportStar(require("./matchup-card"), exports);
__exportStar(require("./news-card"), exports);
__exportStar(require("./score-card"), exports);
__exportStar(require("./score-lockup"), exports);
__exportStar(require("./video-card"), exports);
__exportStar(require("./video-playlist-card"), exports);
// Return type guarded cards
var isLeagueCard = function (component) {
    return component.type === _abstract_1.ComponentType.LeagueCard;
};
exports.isLeagueCard = isLeagueCard;
var isMatchupCard = function (component) {
    return component.type === _abstract_1.ComponentType.MatchupCard;
};
exports.isMatchupCard = isMatchupCard;
var isNewsCard = function (component) {
    return component.type === _abstract_1.ComponentType.NewsCard;
};
exports.isNewsCard = isNewsCard;
var isScoreCard = function (component) {
    return component.type === _abstract_1.ComponentType.ScoreCard;
};
exports.isScoreCard = isScoreCard;
var isVideoCard = function (component) {
    return component.type === _abstract_1.ComponentType.VideoCard;
};
exports.isVideoCard = isVideoCard;
var isVideoPlaylistCard = function (component) {
    return component.type === _abstract_1.ComponentType.VideoPlaylistCard;
};
exports.isVideoPlaylistCard = isVideoPlaylistCard;
